// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticker-container {
  height: 44px;
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.marquee {
  margin: 0 auto;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
}

.marquee span {
  color: white;
  font-family: "Titillium Web", sans-serif;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  /* padding-left: 100%; */
  padding-left: 100%;
  animation: marquee 30s linear infinite;
}

.marquee2 span {
  animation-delay: 15s;
}

@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-110%, 0);
  }
}

.ticker-tape-container {
  overflow-x: hidden;
  /* max-width: 700px; */
  width: 100%;
  display: flex;
  color: #fff;
}

.ticker-tape {
  --direction: normal;
  --duration: 60s;
  --delay: 0s;
  --iteration-count: infinite;
  display: flex;
  gap: 1rem;
  flex: 0 0 auto;
  margin-right: 1rem;
  /* min-width: 100%; */
  align-items: center;
  animation: marquee var(--duration) linear var(--delay) var(--iteration-count);
  animation-play-state: var(--play);
  animation-delay: var(--delay);
  animation-direction: var(--direction);
}

@keyframes scrmarqueeoll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.basic-styling {
  border-radius: 10px;
  background-color: lightblue;
  padding: 2rem;
  color: #fff;
  font-size: 1.5rem;
  font-family: sans-serif;
}

.basic-styling span {
  padding: 0.25rem 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Ticker/ticker.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,6EAA6E;EAC7E,iCAAiC;EACjC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".ticker-container {\n  height: 44px;\n  position: relative;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.marquee {\n  margin: 0 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n.marquee span {\n  color: white;\n  font-family: \"Titillium Web\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  display: inline-block;\n  /* padding-left: 100%; */\n  padding-left: 100%;\n  animation: marquee 30s linear infinite;\n}\n\n.marquee2 span {\n  animation-delay: 15s;\n}\n\n@keyframes marquee {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(-110%, 0);\n  }\n}\n\n.ticker-tape-container {\n  overflow-x: hidden;\n  /* max-width: 700px; */\n  width: 100%;\n  display: flex;\n  color: #fff;\n}\n\n.ticker-tape {\n  --direction: normal;\n  --duration: 60s;\n  --delay: 0s;\n  --iteration-count: infinite;\n  display: flex;\n  gap: 1rem;\n  flex: 0 0 auto;\n  margin-right: 1rem;\n  /* min-width: 100%; */\n  align-items: center;\n  animation: marquee var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n\n@keyframes scrmarqueeoll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.basic-styling {\n  border-radius: 10px;\n  background-color: lightblue;\n  padding: 2rem;\n  color: #fff;\n  font-size: 1.5rem;\n  font-family: sans-serif;\n}\n\n.basic-styling span {\n  padding: 0.25rem 1rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
